import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@/.sourceflow/solutions.json";

export const useSolutions = ({ limit } = {}) => {
  const collection = useSourceFlowCollection(data);

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useSolutions;
